export default {"src":"/_next/static/image/public/images/ic_cart_optics.5e9ff6c6534c677bf8589adcb0f1ad6d.svg","height":56,"width":56};